/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
// import Loader from 'material/loader/loader';
import CTAs from 'material/ctas/ctas';
import EditButton from 'material/ctas/edit/edit';
import SaveButton from 'material/ctas/save/save';
import DiscardButton from 'material/ctas/discard/discard';
// styles
import injectSheet from 'react-jss';
import styles from 'material/ctas/editinfo/editinfo_styles';



/* ========== ~~~~~~~~~~ CTA : EDIT INFO  : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class EditInfoCTA extends Component {
    componentDidUpdate(prevProps) {
		if(!this.props.savingData && prevProps.savingData) { this.props.setFormEditableState(this.props.formName, false) }
	}
	handleEdit = () => {
        this.props.setFormEditableState(this.props.formName, true)
	};
	handleDiscard = () => {
         this.props.discardChanges(this.props.formName);
         this.props.setFormEditableState(this.props.formName, false)
	};
	handleSave = () => {
		this.props.saveFormData();
    };
	render() {
		return (
			<div className={`cta editinfo ${this.props.classes.editinfo}`}>
		        <CTAs>
	                {!this.props.editable ? <EditButton editInfo={this.handleEdit} /> : null}
	                {this.props.editable && <DiscardButton discardChanges={this.handleDiscard} />}
	                {this.props.editable && <SaveButton savingData={this.props.savingData} handleSave={this.handleSave} />}
	            </CTAs>
		    </div>
		);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EditInfoCTA);